export default "__VITE_ASSET__BIjYIYSs__"